import { render, staticRenderFns } from "./ChooseDistrict.html?vue&type=template&id=766f8c82&scoped=true&"
import script from "./ChooseDistrict.vue?vue&type=script&lang=js&"
export * from "./ChooseDistrict.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDistrict.scss?vue&type=style&index=0&id=766f8c82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f8c82",
  null
  
)

export default component.exports